import { useMsal } from "@azure/msal-react";
import { Button } from "@fluentui/react-components";

export const SignOutBtn = () => {
    const { instance } = useMsal();
    const handleSignOut = () => {
        instance.logoutRedirect();
    }

    return (
        <Button onClick={handleSignOut} size="small" appearance="subtle">Sign out</Button>
    )
}